module.exports = __webpack_public_path__ + "img/direct.70593d5b.png";